






import {Component, Vue, Prop} from "vue-property-decorator";
import AttributeSet from "@/api/AttributeSet";
import Product from "@/api/Product";
import RenderProductPrice from "@/components/Shared/RenderProductPrice.vue";
import CompareTableHeaderCell from "@/components/Compare/CompareTable/CompareTableHeaderCell.vue";
import CompareTableGroup from "@/components/Compare/CompareTable/CompareTableGroup.vue";

@Component({
  components: {CompareTableGroup, CompareTableHeaderCell, RenderProductPrice}
})
export default class CompareTableBody extends Vue {
  @Prop() private products!: Product[];
  @Prop() private attributeSet!: AttributeSet;

  get firstProduct(){
    if(this.products && this.products.length > 0) {
      return this.products[0];
    }
    return null;
  }
}
